module.exports = __webpack_public_path__ + "img/linkedin.c95a2f1e.svg";